import React from 'react'
import Page from 'src/components/page'
import Container from 'src/components/container'
import RichText from 'src/components/rich-text'
import { useStore } from 'src/state'

const TermsPage = () => {
  const {
    termsPage: { title, subtitle, body },
  } = useStore()
  return (
    <Page className="page-terms">
      <Container>
        <h1 className="centered">{title}</h1>
        <h3 className="section-title centered">{subtitle}</h3>
        <RichText className="body">{body}</RichText>
      </Container>
    </Page>
  )
}

export default TermsPage
